// Direktiva na renderovanie zapasov dna (na home obrazovke)
directives.topTipsDirective.topTips = function() {
    var directive = {
        "#tipNames .ui-block-1": function () {
            return texts.TopTipsTableHeader;
        },
        "#tipNames .ui-block-2": function () {
            return this.tipNames[0];
        },
        "#tipNames .ui-block-3": function () {
            return this.tipNames[1];
        },
        "#tipNames .ui-block-4": function () {
            return this.tipNames[2];
        },
        "#tipNames .ui-block-5": function () {
            return this.tipNames[3];
        },
        "#tipNames .ui-block-6": function () {
            return this.tipNames[4];
        },
        "#tipNames .ui-block-7": function () {
            return this.tipNames[5];
        },
        "#infoLabelsWrapper #overallRateLabel": function () {
            if (this.TopRateSum) {
                return texts.TopTipsOverallRate + '<span id="overallRate">'
                + shared.formatNumber(shared.floor2(this.TopRateSum, 2), true) + '</span>';
            }
        },
        "#infoLabelsWrapper #overallPriceLabel": function () {
            if (this.TopRateSum) {
                return texts.TopTipsBetAndWin1 + '&nbsp;'
                 + shared.formatNumber(profile.EventsOfDayBet) + '&nbsp;'
                 + profile.Currency + '&nbsp;'
                 + texts.TopTipsBetAndWin2 + '<span id="overallWin">'
                 + shared.floor2(this.TopRateSum * profile.EventsOfDayBet, 1) + '&nbsp;'
                 + profile.Currency + '</span>';
            }
        },
        "#createTopTicketButton .ui-btn-text": function () {
            if (this.TopRateSum) {
                return texts.TopTipsCreateTicket;
            }
        },
        ".event-of-day": {
            "Event<-TopEvents": {
                "@id": function () {
                    if (this.EventID) {
                        return this.EventID;
                    }
                },
                "@event-chancetype-id": function () {
                    if (this.EventChanceTypeID) {
                        return this.EventChanceTypeID;
                    }
                },
                "@chancetype-id": function () {
                    if (this.ChanceTypeID) {
                        return this.ChanceTypeID;
                    }
                },
                "@chancetype-name": function () {
                    if (typeof this.ChanceTypeName !== "undefined") {
                        // ChanceTypeName prichadza ako prazdny string
                        if (this.ChanceTypeName === "") return "&nbsp;"
                        return this.ChanceTypeName;
                    }
                },
                "@league-name": function () {
                    if (this.LeagueCupName) {
                        return this.LeagueCupName;
                    }
                },
                "@region-name": function () {
                    if (this.RegionName) {
                        return this.RegionName;
                    }
                },
                "@sport-name": function () {
                    if (this.SportName) {
                        return this.SportName;
                    }
                },
                "@sport-id": function () {
                    if (this.SportID) {
                        return this.SportID;
                    }
                },
                "@event-date": function () {
                    if (this.EventID && this.date && this.time) {
                        return this.date + ' ' + this.time;
                    }
                },
                ".@event-parent": function () {
                    return this.EventID;
                },
                ".ui-block-1 a@onmousedown": function () {
                    if (this.EventID) {
                        return 'eventDetail.showEventDetail(' + this.EventID + ', false, false, ' + (offer.page === 'results') + ')';
                    }
                },
                ".ui-block-1 a@top-tip": function () {
                    if (this.topTipName) {
                        return this.topTipName;
                    }
                },
                ".ui-block-1 a@top-tip-id": function () {
                    if (this.topTipID) {
                        return this.topTipID;
                    }
                },
                ".ui-block-1 a .ui-btn-text": function () {
                    if (this.SportID && this.RegionID && this.RegionName && this.LeagueCupName && this.date && this.time && this.date && this.team1 && this.team2) {
                        var analysisIcon = this.EventAnalyseID ? true : false;
                        var statisticsIcon = (profile.ShowStatistics && ((profile.StatisticsParameter === "hasBetradarHostedStatistics" && this.Widgets?.includes("statistics")) || (profile.StatisticsParameter === "hasStatistics" && this.HasStatistics))) ? true : false;
                        var ed = '<span class="ui-icon-sports sport-'
                            + this.SportID + ' sport-color-'
                            + this.SportID + ' sport-icon-'
                            + this.SportID + ' region-'
                            + this.RegionID + '"></span><span class="event-date-time"><span class="event-date">'
                            + this.date.substr(0, 6) + ' </span><span class="event-time">'
                            + this.time + '</span></span><div class="day-events-wrapper"><div class="flat-league sport-border-color-'
                            + this.SportID + '"><span class="size22 flag_'
                            + ((this.CountryID) ? this.CountryID : 'none') + '"></span><span>'
                            + this.RegionName + '</span> - '
                            + this.LeagueCupName + '</div><div class="sport-background-colored sport-bgColor-'
                            + this.SportID + '"></div></div><span class="event-name"><span class="team-name">'
                            + this.team1 + '</span><span class="vs">vs.</span><span class="team-name">'
                            + this.team2 + '</span></span><span class="icons-wrapper">';

                            // [Betbuilder Aggregator API] Ikona
                            ed += ((profile.BetBuilderAgg && this.Widgets?.includes("betbuilder")) ? `<span class="icon icon-betbuilder--agg ${this.LiveBetting === "Y" && !profile.BetBuilderAggLive ? "icon-betbuilder--agg--hidden" : ""}"></span>` : '');

                            // pridavam k eventu ikony ak mam analyzy a/alebo stitistiky
                            if (analysisIcon && statisticsIcon) {
                                // obe
                                ed += '<span class="icon analysis-h2h-ico event-analysis-' + this.EventAnalyseID + '"></span>';
                            } else {
                                if (analysisIcon) {
                                    // len analyzy
                                    ed += '<span class="icon analysis-ico event-analysis-' + this.EventAnalyseID + '"></span>';
                                }
                                if (statisticsIcon) {
                                    // len statistiky
                                    ed += '<span class="icon h2h-ico"></span>';
                                }
                            }
                            ed += '</span>';
                        return ed;
                    }
                },
                ".ui-block-2 a@id": function () {
                    if (this.odds["1"] && this.odds["1"].oddID) {
                        return this.odds["1"].oddID;
                    }
                },
                ".ui-block-2 a@tip-team-name": function () {
                    if (this.odds["1"] && this.odds["1"].tipTeamName) {
                        return this.odds["1"].tipTeamName;
                    }
                },
                ".ui-block-2 a@class+": function () {
                    if (this.odds["1"]) {
                        var oddClass;
                        if (this.odds["1"].isTopTip) {
                            oddClass = " top-tip";
                        }
                        if (list.Odds.indexOf(this.odds["1"].oddID) !== -1) {
                            this.oddOnTicket = true;
                            oddClass += " ui-btn-up-e";
                        }
                        return oddClass;
                    }
                },
                ".ui-block-2 a@onmousedown": function () {
                    if (this.odds["1"] && typeof this.odds["1"].oddID === "number") {
                        return "ticket.ticketOddModule.ctAddOdd(" + this.odds["1"].oddID + ", null)";
                    }
                },
                ".ui-block-2 a .ui-btn-text": function () {
                    if (this.odds["1"] && this.odds["1"].oddRate) {
                        var oddBlock = "<span class='odd-rate'>" + this.odds["1"].oddRate + "</span>";
                        return oddBlock;
                    }
                },
                ".ui-block-3 a@id": function () {
                    if (this.odds["X"] && this.odds["X"].oddID) {
                        return this.odds["X"].oddID;
                    }
                },
                ".ui-block-3 a@tip-team-name": function () {
                    if (this.odds["X"] && this.odds["X"].tipTeamName) {
                        return this.odds["X"].tipTeamName;
                    }
                },
                ".ui-block-3 a@class+": function () {
                    if (this.odds["X"]) {
                        var oddClass;
                        if (this.odds["X"].isTopTip) {
                            oddClass = " top-tip";
                        }
                        if (list.Odds.indexOf(this.odds["X"].oddID) !== -1) {
                            this.oddOnTicket = true;
                            oddClass += " ui-btn-up-e";
                        }
                        return oddClass;
                    }
                },
                ".ui-block-3 a@onmousedown": function () {
                    if (this.odds["X"] && typeof this.odds["X"].oddID === "number") {
                        return "ticket.ticketOddModule.ctAddOdd(" + this.odds["X"].oddID + ", null)";
                    }
                },
                ".ui-block-3 a .ui-btn-text": function () {
                    if (this.odds["X"] && this.odds["X"].oddRate) {
                        var oddBlock = "<span class='odd-rate'>" + this.odds["X"].oddRate + "</span>";
                        return oddBlock;
                    }
                },
                ".ui-block-4 a@id": function () {
                    if (this.odds["2"] && this.odds["2"].oddID) {
                        return this.odds["2"].oddID;
                    }
                },
                ".ui-block-4 a@tip-team-name": function () {
                    if (this.odds["2"] && this.odds["2"].tipTeamName) {
                        return this.odds["2"].tipTeamName;
                    }
                },
                ".ui-block-4 a@class+": function () {
                    if (this.odds["2"]) {
                        var oddClass;
                        if (this.odds["2"].isTopTip) {
                            oddClass = " top-tip";
                        }
                        if (list.Odds.indexOf(this.odds["2"].oddID) !== -1) {
                            this.oddOnTicket = true;
                            oddClass += " ui-btn-up-e";
                        }
                        return oddClass;
                    }
                },
                ".ui-block-4 a@onmousedown": function () {
                    if (this.odds["2"] && typeof this.odds["2"].oddID === "number") {
                        return "ticket.ticketOddModule.ctAddOdd(" + this.odds["2"].oddID + ", null)";
                    }
                },
                ".ui-block-4 a .ui-btn-text": function () {
                    if (this.odds["2"] && this.odds["2"].oddRate) {
                        var oddBlock = "<span class='odd-rate'>" + this.odds["2"].oddRate + "</span>";
                        return oddBlock;
                    }
                },
                ".ui-block-5 a@id": function () {
                    if (this.odds["1X"] && this.odds["1X"].oddID) {
                        return this.odds["1X"].oddID;
                    }
                },
                ".ui-block-5 a@tip-team-name": function () {
                    if (this.odds["1X"] && this.odds["1X"].tipTeamName) {
                        return this.odds["1X"].tipTeamName;
                    }
                },
                ".ui-block-5 a@class+": function () {
                    if (this.odds["1X"]) {
                        var oddClass;
                        if (this.odds["1X"].isTopTip) {
                            oddClass = " top-tip";
                        }
                        if (list.Odds.indexOf(this.odds["1X"].oddID) !== -1) {
                            this.oddOnTicket = true;
                            oddClass += " ui-btn-up-e";
                        }
                        return oddClass;
                    }
                },
                ".ui-block-5 a@onmousedown": function () {
                    if (this.odds["1X"] && typeof this.odds["1X"].oddID === "number") {
                        return "ticket.ticketOddModule.ctAddOdd(" + this.odds["1X"].oddID + ", null)";
                    }
                },
                ".ui-block-5 a .ui-btn-text": function () {
                    if (this.odds["1X"] && this.odds["1X"].oddRate) {
                        var oddBlock = "<span class='odd-rate'>" + this.odds["1X"].oddRate + "</span>";
                        return oddBlock;
                    }
                },
                ".ui-block-6 a@id": function () {
                    if (this.odds["12"] && this.odds["12"].oddID) {
                        return this.odds["12"].oddID;
                    }
                },
                ".ui-block-6 a@tip-team-name": function () {
                    if (this.odds["12"] && this.odds["12"].tipTeamName) {
                        return this.odds["12"].tipTeamName;
                    }
                },
                ".ui-block-6 a@class+": function () {
                    if (this.odds["12"]) {
                        var oddClass;
                        if (this.odds["12"].isTopTip) {
                            oddClass = " top-tip";
                        }
                        if (list.Odds.indexOf(this.odds["12"].oddID) !== -1) {
                            this.oddOnTicket = true;
                            oddClass += " ui-btn-up-e";
                        }
                        return oddClass;
                    }
                },
                ".ui-block-6 a@onmousedown": function () {
                    if (this.odds["12"] && typeof this.odds["12"].oddID === "number") {
                        return "ticket.ticketOddModule.ctAddOdd(" + this.odds["12"].oddID + ", null)";
                    }
                },
                ".ui-block-6 a .ui-btn-text": function () {
                    if (this.odds["12"] && this.odds["12"].oddRate) {
                        var oddBlock = "<span class='odd-rate'>" + this.odds["12"].oddRate + "</span>";
                        return oddBlock;
                    }
                },
                ".ui-block-7 a@id": function () {
                    if (this.odds["X2"] && this.odds["X2"].oddID) {
                        return this.odds["X2"].oddID;
                    }
                },
                ".ui-block-7 a@tip-team-name": function () {
                    if (this.odds["X2"] && this.odds["X2"].tipTeamName) {
                        return this.odds["X2"].tipTeamName;
                    }
                },
                ".ui-block-7 a@class+": function () {
                    if (this.odds["X2"]) {
                        var oddClass;
                        if (this.odds["X2"].isTopTip) {
                            oddClass = " top-tip";
                        }
                        if (list.Odds.indexOf(this.odds["X2"].oddID) !== -1) {
                            this.oddOnTicket = true;
                            oddClass += " ui-btn-up-e";
                        }
                        return oddClass;
                    }
                },
                ".ui-block-7 a@onmousedown": function () {
                    if (this.odds["X2"] && typeof this.odds["X2"].oddID === "number") {
                        return "ticket.ticketOddModule.ctAddOdd(" + this.odds["X2"].oddID + ", null)";
                    }
                },
                ".ui-block-7 a .ui-btn-text": function () {
                    if (this.odds["X2"] && this.odds["X2"].oddRate) {
                        var oddBlock = "<span class='odd-rate'>" + this.odds["X2"].oddRate + "</span>";
                        return oddBlock;
                    }
                },
                ".ui-block-8 a@onmousedown": function () {
                    if (this.EventID) {
                        return 'eventDetail.showEventDetail(' + this.EventID + ', false, false, ' + (offer.page === 'results') + ')';
                    }
                },
                ".ui-block-8 a@class+": function () {
                    if ((list.Events.indexOf(String(this.EventID)) !== -1) && !this.oddOnTicket) {
                        return " ui-btn-up-e";
                    }
                },
            }
        }
    }
    T.TopTips = $p("#popularLeaguesTopTips #topTips").compile(directive);
};
